import { Radio } from 'antd'
import styled from 'styled-components'

export const RadioGroup = styled(Radio.Group)`
  width: 100%;
`
